export default __webpack_public_path__ + "static/media/background.b7ba5cb5.png";